/**
 * Leaves the app by loading a fresh document, so nothing held in memory —
 * the API caches, component state, object URLs — survives the move. A router
 * navigation keeps all three, which is why this is not `useNavigate`.
 *
 * The entry being left is replaced rather than stacked, so Back does not return
 * to a page the reader can no longer see.
 */
const reloadTo = (path: string) => {
  window.location.replace(path);
};

export default reloadTo;
